import { Link } from '@radix-ui/themes'
import { dhlTrackingUrl } from '../service'

interface TrackingNumberLinkProps {
  trackingNumber: string
  size?: '1' | '2'
}

export const TrackingNumberLink = ({ trackingNumber, size = '2' }: TrackingNumberLinkProps) => (
  <Link
    size={size}
    href={dhlTrackingUrl(trackingNumber)}
    target="_blank"
    rel="noreferrer"
    className="whitespace-nowrap"
  >
    {trackingNumber}
  </Link>
)
